import * as React from 'react';
import Modal from 'telstra-ui/components/modal/Modal';
import { Button } from 'telstra-ui/components/button/Button';
import Icon from 'telstra-ui/components/icons/Icon';
import './style.less';
import { Application } from '@applications/billing';
import { ActivityTracking } from '@telstra-connect/billing';

interface IModalComponentProps {
    bodyContent: any;
    headerContent: string;
    when: boolean;
    buttonLabel?: string;
    onConfirmClick?: () => void;
    onCancelClick?: () => void;
}

export class AlertModalComponent extends React.Component<IModalComponentProps> {
    public render() {
        return (
            <div className="tc-alert-container">
                <Modal
                    isOpen={this.props.when}
                    modalType="alert-modal-warning"
                    onShowModal={this.closeModal}
                >
                    <Modal.Header  isClosable={false}>
                        <div className='delete-modal-header'>
                            <svg className="tl-svg-info-icon">
                                <Icon name="icon-system-alert-small" />
                            </svg>
                            <div>{this.props.headerContent}</div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>{this.props.bodyContent}</Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            size="small"
                            label="Cancel"
                            className="button-pull-left"
                            onClick={this.closeModal}
                        />
                        <Button
                            variant="super"
                            size="medium"
                            state="warning"
                            label={this.props.buttonLabel || 'Continue' }
                            onClick={ this.onConfirmClick }
                        />
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }

    private readonly onConfirmClick = () => {
        this.props.onConfirmClick();
    }

    private readonly closeModal = () => {
        Application.tracker.trackLink(ActivityTracking.Components.closeWarningComponent, 'Close WarningComponent')
        this.props.onCancelClick();
    }
}
